export default __webpack_public_path__ + "static/media/carousel2.de62cb44.jpg";